"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.saveFacilitySession = saveFacilitySession;
exports.loadFacilitySession = loadFacilitySession;
exports.clearFacilitySession = clearFacilitySession;
var FACILITY_STORAGE_KEY = "facility";
function saveFacilitySession(facility) {
    localStorage.setItem(FACILITY_STORAGE_KEY, JSON.stringify(facility));
}
function loadFacilitySession() {
    var raw = localStorage.getItem(FACILITY_STORAGE_KEY);
    if (!raw)
        return null;
    try {
        return JSON.parse(raw);
    }
    catch (_a) {
        return null;
    }
}
function clearFacilitySession() {
    localStorage.removeItem(FACILITY_STORAGE_KEY);
}
